import z from 'zod';
export const scheduleEntryTimeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d|^24:00$/;
export const scheduleEntry = z.object({
    daysOfWeek: z.number().min(1).max(7).array(),
    timeStart: z.string().regex(scheduleEntryTimeRegex),
    timeEnd: z.string().regex(scheduleEntryTimeRegex),
});
export const schedule = z.object({
    entries: scheduleEntry.array(),
});
